import { render, staticRenderFns } from "./PageDataMatrixSale.vue?vue&type=template&id=423d3ae4&scoped=true&"
import script from "./PageDataMatrixSale.vue?vue&type=script&lang=js&"
export * from "./PageDataMatrixSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423d3ae4",
  null
  
)

export default component.exports